export default {
  APP: "APP",
  CUSTOMERS: "CUSTOMERS",
  SUPPLIERS: "SUPPLIERS",
  CONTACTS: "CONTACTS",
  PRODUCTS: "PRODUCTS",
  FOLDERS: "FOLDERS",
  LOCATIONS: "LOCATIONS",
  ORGANIZATIONS: "ORGANIZATIONS",
  SUBSCRIPTIONS: "SUBSCRIPTIONS",
  PACKAGES: "PACKAGES",
  RESELLERS: "RESELLERS",
  USERS: "USERS",
  ROLES: "ROLES",
  PERMISSIONS: "PERMISSIONS",
  LOGS: "LOGS",
  PURCHASES_ORDERS: "PURCHASES_ORDERS",
  PURCHASES_INVOICES: "PURCHASES_INVOICES",
  PURCHASES_DELIVERIES: "PURCHASES_DELIVERIES",
  PURCHASES_PAYMENTS: "PURCHASES_PAYMENTS",
  SALES_ORDERS: "SALES_ORDERS",
  SALES_INVOICES: "SALES_INVOICES",
  SALES_DELIVERIES: "SALES_DELIVERIES",
  SALES_PAYMENTS: "SALES_PAYMENTS",
  RESELLER_INVOICES: "RESELLER_INVOICES",
  RESELLER_PAYMENTS: "RESELLER_PAYMENTS",
  RESELLER_PRODUCTS: "RESELLER_PRODUCTS",
  RESELLER_SERVICES: "RESELLER_SERVICES",
  WAREHOUSES: "WAREHOUSES",
  STOCK_MOVEMENTS: "STOCK_MOVEMENTS",
  IMPORTS: "IMPORTS",
  PROPERTIES: "PROPERTIES",
  AUCTIONS: "AUCTIONS",
  OTHER_FEES: "OTHER_FEES",
  PROPERTY_TRANSACTIONS: "PROPERTY_TRANSACTIONS",
  ORGANIZATION_TEMPLATES: "ORGANIZATION_TEMPLATES",
  DPA_ACCOUNTS: "DPA_ACCOUNTS",
  DPAPAYMENTS: "DPAPAYMENTS",
  DPATRANSACTIONS: "DPATRANSACTIONS",
  CONTRACTS: "CONTRACTS",
  CONTRACTFILES: "CONTRACTFILES",
  SIGNATURES: "SIGNATURES",
  FILES: "FILES",
  TEMPLATES_MAILS: "TEMPLATES_MAILS",
  NUVEI_CARDS: "NUVEI_CARDS",
  NUVEI_TRANSACTIONS: "NUVEI_TRANSACTIONS",
  ELIXIOPAY_TRANSACTIONS: "ELIXIOPAY_TRANSACTIONS",
  THIRD_PARTY_SERVICES: "THIRD_PARTY_SERVICES",
  WORKSPACE_MEMBERS: "WORKSPACE_MEMBERS",
  WORKSPACE_CUSTOMERS: "WORKSPACE_CUSTOMERS",
  CATEGORIES: "CATEGORIES",
  OPTIONS: "OPTIONS",
  MAIL_TEMPLATE_VARIABLES: "MAIL_TEMPLATE_VARIABLES",
  TYPE_MAILS: "TYPE_MAILS",
};
